/*
  assets/collection-carousel.js
  Prev/next arrow scrolling for .cgp-car-track. Wishlist, color swatch,
  and quick-add clicks inside each card are handled entirely by
  collection-grid-with-promos.js (loaded alongside this file) since the
  cards are the exact same markup — nothing carousel-specific needed
  for that logic.
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-cgp-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-cgp-car-track]');
      var prevBtn = wrap.querySelector('[data-cgp-car-prev]');
      var nextBtn = wrap.querySelector('[data-cgp-car-next]');
      if (!track) return;

      function scrollByOneCard(direction) {
        var item = track.querySelector('.cgp-car-item');
        var amount = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      function updateArrowState() {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) {
          var maxScroll = track.scrollWidth - track.clientWidth;
          nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOneCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOneCard(1); });

      track.addEventListener('scroll', updateArrowState, { passive: true });
      updateArrowState();
    });
  });
})();
